import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, promptDetailFeatureKey } from './prompt-detail.reducer';

export const promptDetailFeature = createFeatureSelector<State>(promptDetailFeatureKey);

export const getPrompt = createSelector(promptDetailFeature, (state) => {
   return state.prompt;
});

export const getPromptCallState = createSelector(promptDetailFeature, (state) => {
   return state.callState;
});

export const selectPromptDetailState = createFeatureSelector<State>(promptDetailFeatureKey);

export const selectQueryComplete = createSelector(selectPromptDetailState, (state: State) => state.queryComplete);
